class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('.mobile-facets__close').forEach((button) => {
      button.addEventListener('click', this.onCloseButtonClick.bind(this), true);
    });
    // Filter drawer: the transparent full-screen overlay outside the sliding
    // panel catches clicks (the body backdrop sits under it); clicking there
    // closes the drawer, like the cart/nav backdrop.
    const overlay = this.querySelector('.mobile-facets');
    if (overlay) {
      overlay.addEventListener('click', (event) => {
        if (!event.target.closest('.mobile-facets__inner')) this.closeMenuDrawer(event);
      });
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    // Ignore clicks on the close button
    if (event.target.closest('.mobile-facets__close')) {
      return;
    }

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    document.body.classList.add('overflow-hidden');
    // Body-level backdrop so the WHOLE page (header/nav incl.) dims uniformly,
    // like the cart drawer. A dim nested inside the sticky filter bar's stacking
    // context does not composite over the top of the page reliably.
    if (!this._facetsBackdrop) {
      this._facetsBackdrop = document.createElement('div');
      this._facetsBackdrop.className = 'mobile-facets-backdrop';
      // Click on the backdrop closes the filter drawer (like the cart/nav drawer).
      this._facetsBackdrop.addEventListener('click', (e) => this.closeMenuDrawer(e));
    }
    document.body.appendChild(this._facetsBackdrop);
    // WAAPI fade — reliable for a freshly-created element (CSS transitions can be skipped)
    this._facetsBackdrop.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 400, easing: 'ease', fill: 'forwards' });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      // Fade the backdrop out in step with the panel slide-out (WAAPI, reliable).
      if (this._facetsBackdrop) {
        this._facetsBackdrop.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 400, easing: 'ease', fill: 'forwards' });
      }
      // Let the panel slide out (transition) before removing [open] / the backdrop
      // so the close matches the cart drawer instead of vanishing instantly.
      const toggle = this.mainDetailsToggle;
      const backdrop = this._facetsBackdrop;
      window.setTimeout(() => {
        toggle.querySelectorAll('details').forEach((details) => details.removeAttribute('open'));
        toggle.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
      }, 500);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const detailsElement = event.currentTarget.closest('details');
    this.closeMenuDrawer(event, detailsElement.querySelector('summary'));
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('menu-drawer', MenuDrawer);
